import { Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import { ColorDynamic } from '@superdispatch/ui';
import { TextBox } from '@superdispatch/ui-lab';
import { LooseItemsDTO } from '../../../loads/data/LoadDTO';
import styled from 'styled-components';

const StyledTable = styled(Table)`
  .MuiTableCell-root {
    border-bottom: 1px solid ${ColorDynamic.Silver400};
  }
`;

const StyledTableCell = styled(TableCell)`
  &[data-color='green'] {
    background-color: ${ColorDynamic.Green50};
  }
  &[data-color='red'] {
    background-color: ${ColorDynamic.Red50};
  }
`;

type LooseItemsNames = {
  [T in keyof LooseItemsDTO]: string;
};

const labels: LooseItemsNames = {
  type: 'Type',
  valet_keys_count: 'Keys',
  remotes_count: 'Remotes',
  headrests_count: 'Headrests',
  is_drivable: 'Drivable',
  windscreen_present: 'Windscreen',
  all_glasses_ok: 'Glass (all intact)',
  title_present: 'Title',
  cargo_cover_present: 'Cargo Cover',
  spare_tire_present: 'Spare Tire',
  radio_present: 'Radio',
  manuals_present: 'Manual(s)',
  navigation_disk_present: 'Navigation Disk',
  plugin_charger_cable_present: 'Plugin Charger Cable',
  headphones_present: 'Headphones',
  odometer: 'Odometer',
};

const properties = Object.keys(labels).filter((x) => x !== 'type') as Array<
  Exclude<keyof LooseItemsDTO, 'type'>
>;

export function hasLooseItem(looseItems: Partial<LooseItemsDTO>) {
  return properties.some(
    (key) =>
      looseItems[key] !== undefined &&
      looseItems[key] !== null &&
      looseItems[key] !== '',
  );
}

function formatLooseItemValue(value: boolean | number | string) {
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No';
  }

  return value;
}

interface Props {
  looseItems: LooseItemsDTO;
}

export function ViewLoadInspectionLooseItems({ looseItems }: Props) {
  return (
    <StyledTable size="small">
      <TableBody>
        {properties.map((key) => {
          const value = looseItems[key];

          if (typeof value === 'boolean') {
            return (
              <TableRow key={key}>
                <StyledTableCell data-color={value ? 'green' : 'red'}>
                  {labels[key]}
                </StyledTableCell>
                <StyledTableCell data-color={value ? 'green' : 'red'}>
                  <TextBox
                    color={value ? 'green' : 'red'}
                    variant="body-semibold"
                  >
                    {formatLooseItemValue(value)}
                  </TextBox>
                </StyledTableCell>
              </TableRow>
            );
          }

          if (value != null) {
            return (
              <TableRow key={key}>
                <TableCell>{labels[key]}</TableCell>
                <StyledTableCell>{formatLooseItemValue(value)}</StyledTableCell>
              </TableRow>
            );
          }

          return null;
        })}
      </TableBody>
    </StyledTable>
  );
}
